import {Component, inject, signal} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {
  NotificationContainerComponent
} from '@app/shared/components/notification-container/notification-container.component';
import {LogThemeService} from './core/services/log-theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NotificationContainerComponent],
  templateUrl: './app.html',
})
export class App {
  protected readonly title = signal('client-app');

  // Initialize theme service on app start
  private logThemeService = inject(LogThemeService);
}
